import * as Sentry from '@sentry/angular';

const SentryConfig = {
  dsn: 'https://a722dc5af1d8ae5ff6131cac0697042f@o4508608103645184.ingest.de.sentry.io/4510244134256720',
};

export const sentryInit = (): void => {
  Sentry.init({
    dsn: SentryConfig.dsn,
    integrations: [],
  });
};
